import { render, staticRenderFns } from "./CommunityWorkNewsCard.vue?vue&type=template&id=ad6c54e6&scoped=true&"
import script from "./CommunityWorkNewsCard.vue?vue&type=script&lang=js&"
export * from "./CommunityWorkNewsCard.vue?vue&type=script&lang=js&"
import style0 from "./CommunityWorkNewsCard.vue?vue&type=style&index=0&id=ad6c54e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6c54e6",
  null
  
)

export default component.exports